import { render, staticRenderFns } from "./dialog-detailresend.vue?vue&type=template&id=193c2f80&"
import script from "./dialog-detailresend.vue?vue&type=script&lang=js&"
export * from "./dialog-detailresend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports